import React, { useEffect, useState } from 'react';
import uri from '../utils/uri';
import http from '../utils/http';

import { AppBar, Toolbar, Typography } from '@mui/material';

import { ConfigContext } from './ConfigContext';
import './style.css';

export const ConfigProvider = (props) => {
    const [loading, setLoading] = useState(true);
    const [config, setConfig] = useState({});
    const [fetchError, setFetchError] = useState(false);
    const localStorageKey = `${process.env.REACT_APP_APPID}_uiConfig`;

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const result = await http.get({}, `${uri.base}/config`, { authHeader: false });
                localStorage.setItem(localStorageKey, JSON.stringify(result));
                setConfig(result);
                setFetchError(false);
            } catch (error) {
                console.error('Failed to fetch config from API, using local storage if available', error);
                const storedConfig = localStorage.getItem(localStorageKey);
                if (storedConfig) {
                    setConfig(JSON.parse(storedConfig));
                } else {
                    console.error('No local config found');
                    setFetchError(true);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchConfig();
    }, [localStorageKey]);

    return (
        <>
            {fetchError && (
                <AppBar position="static" style={{ height: '25px', backgroundColor: 'red' }}>
                    <Toolbar variant="dense" style={{ minHeight: '25px' }}>
                        <Typography variant="caption" color="inherit">
                            Unable to fetch configuration data from the API
                        </Typography>
                    </Toolbar>
                </AppBar>
            )}
            {loading && !fetchError && (
                <AppBar position="static" style={{ height: '25px', backgroundColor: 'green' }}>
                    <Toolbar variant="dense" style={{ minHeight: '25px' }}>
                        <Typography variant="caption" color="inherit">
                            Loading configuration data...
                        </Typography>
                    </Toolbar>
                </AppBar>
            )}
            {!loading && !fetchError && (
                <ConfigContext.Provider value={{ config, setConfig }}>
                    {props.children}
                </ConfigContext.Provider>
            )}
        </>
    );
};
